export default __webpack_public_path__ + "static/media/icon-letter.cabbab2c.svg";